import React, { useEffect, useState } from 'react';
interface ControlNumberFieldProps {
  value: number;
  onCommit: (next: number) => void;
  label: string;
  min?: number;
  max?: number;
  className?: string;
  /** Shown before the number. Defaults to "$". Pass "" for none. */
  prefix?: string;
  /** Shown after the number, e.g. "%". */
  suffix?: string;
  /** Allow one decimal place (e.g. 4.5 sales a month). */
  allowDecimal?: boolean;
}

/** Compact number input that commits on Enter or when focus leaves. */
export function ControlNumberField({
  value,
  onCommit,
  label,
  min = 0,
  max = 10_000_000,
  className = '',
  prefix = '$',
  suffix = '',
  allowDecimal = false
}: ControlNumberFieldProps) {
  const [draft, setDraft] = useState(String(value));
  useEffect(() => setDraft(String(value)), [value]);
  const commit = () => {
    const raw = Number(draft.replace(/[^0-9.]/g, ''));
    const parsed = allowDecimal ? Math.round(raw * 10) / 10 : Math.round(raw);
    if (!Number.isFinite(parsed) || draft.trim() === '') {
      setDraft(String(value));
      return;
    }
    const next = Math.min(max, Math.max(min, parsed));
    setDraft(String(next));
    if (next !== value) onCommit(next);
  };
  const display = allowDecimal ? draft : Number(draft) ? Number(draft).toLocaleString('en-US') : draft;
  return <label className={`flex items-center rounded-md border border-slate-700 bg-[#0A0F1C] px-2 focus-within:border-[#7FE0C3] transition-colors duration-150 ease-out ${className}`} data-id="element-1261" data-mp="1eo5l2zlin7gq">
      {prefix && <span className="text-[12px] text-slate-500" aria-hidden="true" data-id="element-1262" data-mp="1npdf35h01m50">
          {prefix}
        </span>}
      <input type="text" inputMode={allowDecimal ? 'decimal' : 'numeric'} aria-label={label} value={display} onChange={e => setDraft(e.target.value.replace(allowDecimal ? /[^0-9.]/g : /[^0-9]/g, ''))} onBlur={commit} onKeyDown={e => {
      if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
    }} className="w-full min-w-0 bg-transparent py-1.5 pl-0.5 text-[13px] font-semibold tabular-nums text-slate-100 focus:outline-none" data-id="element-1263" data-mp="22dzrozf8rzsj" />
      {suffix && <span className="text-[12px] text-slate-500" aria-hidden="true" data-id="element-1264" data-mp="1d23lodl2nws7">
          {suffix}
        </span>}
    </label>;
}